import { CheckIcon, CompassIcon, EllipsisIcon, EquipmentIcon, PlusIcon, WriteIcon } from "@xola/icons";
import { Dot, Skeleton, Spinner } from "@xola/ui-kit";
import { DateFormat } from "common";
import dayjs from "dayjs";
import { range } from "lodash";
import React from "react";

export const DashboardListSkeleton = ({ date = dayjs(), rows = 3 }) => {
    return (
        <div>
            <Skeleton height={48} classNames={{ container: "px-4 !justify-start" }}>
                <div className="flex h-11 items-center space-x-4 px-6 xl:px-10">
                    <div className="flex h-7.5 flex-row space-x-6 text-lg font-bold">
                        <div className="font-bold">{dayjs(date).format(DateFormat.DATE_MONTH)}</div>
                    </div>

                    <div className="mr-3">
                        Loading <b>{dayjs(date).format("dddd")}&apos;s</b> data <Spinner className="p-2" />
                    </div>
                </div>
            </Skeleton>
            {range(rows).map((index) => (
                <SkeletonRow key={index} />
            ))}
        </div>
    );
};

const SkeletonRow = () => {
    return (
        <Skeleton
            shouldAnimate
            height="87px"
            classNames={{ container: "w-full px-4 !bg-white !justify-start", text: "w-full !text-black" }}
        >
            <div className="flex w-full border-b border-b-gray-lighter py-3">
                <div className="flex-shrink-0">
                    <Skeleton height={56} classNames={{ container: "mr-3" }}>
                        <div className="mr-3 h-14 w-14 rounded" />
                    </Skeleton>
                </div>
                <div className="flex flex-grow flex-col">
                    <div className="h-5 w-full">
                        <div className="w-1/3 rounded-sm bg-gray-lighter">&nbsp;</div>
                    </div>
                    <div className="flex justify-between">
                        <div className="flex w-72 flex-col">
                            <div className="space-x-2 pt-2 font-bold">
                                <span className="text-gray">
                                    <div className="mr-1 inline-block w-5 rounded-sm bg-gray-lighter">&nbsp;</div>
                                    Available
                                </span>
                                <span className="text-gray">
                                    <span className="mr-2 opacity-20">·</span>
                                    <div className="mr-1 inline-block w-5 rounded-sm bg-gray-lighter">&nbsp;</div>
                                    Reserved
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center space-x-2 text-gray-darker 2xl:space-x-4">
                            <div className="w-16">
                                <Dot color="secondary" className="mr-1 align-middle" />
                                <span className="mr-1.5 text-gray">
                                    <CheckIcon />
                                </span>
                                <span className="align-middle">
                                    <div className="mr-1 inline-block w-5 rounded-sm bg-gray-lighter text-gray">
                                        &nbsp;
                                    </div>
                                </span>
                            </div>
                            <div className="w-16">
                                <Dot color="secondary" className="mr-1 align-middle" />
                                <span className="mr-1.5 text-gray">
                                    <WriteIcon />
                                </span>
                                <span className="align-middle">
                                    <div className="mr-1 inline-block w-5 rounded-sm bg-gray-lighter text-gray">
                                        &nbsp;
                                    </div>
                                </span>
                            </div>
                            <div className="w-14" />
                        </div>
                        <div className="flex items-center text-gray-darker lg:space-x-2">
                            <div className="w-24 truncate xl:w-28 2xl:w-32">
                                <Dot color="secondary" className="mr-1 align-middle" />
                                <span className="mr-1.5 text-gray">
                                    <CompassIcon />
                                </span>
                                <span className="align-middle">
                                    <div className="mr-1 inline-block w-14 rounded-sm bg-gray-lighter text-gray">
                                        &nbsp;
                                    </div>
                                </span>
                            </div>
                            <div className="w-24 truncate xl:w-28 2xl:w-32">
                                <Dot color="secondary" className="mr-1 align-middle" />
                                <span className="mr-1.5 text-gray">
                                    <EquipmentIcon />
                                </span>
                                <span className="align-middle">
                                    <div className="mr-1 inline-block w-14 rounded-sm bg-gray-lighter text-gray">
                                        &nbsp;
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4">
                            <div className="w-12">
                                <span className="inline-flex h-7.5 items-center rounded-full border border-yellow-lighter bg-gray-lighter py-1.5 px-3 leading-base text-gray">
                                    ?
                                </span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <div className="inline-flex h-7.5 w-7.5 items-center rounded border border-gray-light py-2 px-2 text-base leading-base text-gray transition-colors">
                                    <EllipsisIcon />
                                </div>
                                <div className="inline-flex h-7.5 w-7.5 items-center rounded border border-green-lighter py-2 px-2 text-base leading-base text-gray transition-colors">
                                    <PlusIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Skeleton>
    );
};
